import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useUIStateStore } from "@/store/uiStateStore";

import { useGetMyAccount, useGetMyWriters } from "../../../../api/queries";
import { hasAdminRights } from "../../../../auth/shared";
import H2 from "../../../../components/H2";
import LoadingSmall from "../../../../components/LoadingSmall";
import RebrandButtonLink from "../../../../components/RebrandButtonLink";
import Spacer from "../../../../components/Spacer";
import useGetColours from "../../../../helpers/getColours";
// import AppState from "../../../../store/appstate";
import useAppStore from "../../../../store/appStateZustand";
import WritersTable from "./WritersTable";

function Writers() {
  const { t } = useTranslation("writers");
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const history = useHistory();

  const isTunecore = useUIStateStore(state => state.isTunecore);

  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });

  const writers = useGetMyWriters({ aac: selectedAccount });

  const { highlightColour, statusErrorColour } = useGetColours();

  const adminRights = hasAdminRights(myAccount?.data);

  useEffect(() => {
    if (selectedAccount) {
      writers.refetch();
    }
  }, [selectedAccount, writers]);

  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <div className="flex flex-wrap items-baseline justify-between">
            <div>
              <H2>{t("writers:writers-header")}</H2>
            </div>
            <div>
              <RebrandButtonLink
                plusIcon
                id="btnWriterAddNew"
                onClick={
                  adminRights
                    ? () => history.push("/writers/create")
                    : undefined
                }
              >
                {t("writers:add-new-writer-button2")}
              </RebrandButtonLink>
            </div>
          </div>
          <Spacer />
          <div
            className={`${
              isTunecore ? "bg-tunecore-dark-element" : " bg-white"
            } rounded-lg p-4 lg:p-8`}
          >
            {!writers.isSuccess && <LoadingSmall />}
            {writers.isSuccess && writers?.data?.writers && (
              <WritersTable
                highlightColour={highlightColour}
                errorColour={statusErrorColour}
                data={writers?.data?.writers}
              />
            )}
          </div>
          <Spacer />
        </div>
      </div>
    </div>
  );
}
export default Writers;
